<template>
  <div class="relative flex items-center form-input">
    <fa :icon="['far', 'boxes']" class="mr-3 text-gray-400" />
    <input ref="input" type="text" placeholder="Search Products" class="flex-grow p-0 border-0 focus:ring-0" v-model="search" @input="searchProducts" @focus="focused = true" @blur="blur">
    <div class="absolute left-0 z-10 w-full py-2 overflow-y-auto transform translate-y-1 bg-white border rounded shadow-lg max-h-56 top-full" v-show="results.data && focused">
      <div v-if="results.meta && results.meta.total === 0" class="p-4 text-sm text-center text-gray-500">
        No products found.
      </div>
      <template v-else>
        <button type="button" v-for="(result, index) in results.data" :id="`result-${index}`" :key="result.id" class="block w-full text-left transition-colors duration-75 hover:bg-gray-50 hover:text-gray-800" :class="{ 'bg-accent bg-opacity-10': index === highlightedIndex }" @click.prevent="select(result)">
          <div class="px-4 py-2">
            <div class="flex items-center">
              <span class="font-medium">
                {{ result.name }}
              </span>
            </div>
            <span class="text-sm text-gray-500">
              <currency :value="result.price" :currency-code="account.currency" :subunits-value="true" />
            </span>
          </div>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductSearch',

  mounted() {
    this.$el.addEventListener('keydown', this.keyHandler)
  },

  destroyed() {
    this.$el.removeEventListener('keydown', this.keyHandler)
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      focused: false,
      loading: false,
      search: '',
      highlightedIndex: null,
      results: {}
    }
  },

  methods: {
    keyHandler (event) {
      if (this.focused) {
        if (event.key === 'Escape') {
          this.$refs.input.blur()
          this.highlightedIndex = null
          this.search = ''
          this.results = {}
        } 

        if (this.results.data && this.results.data.length > 0) {
          if (event.key === 'ArrowDown') {
            if (this.highlightedIndex === null) {
              this.highlightedIndex = 0
            } else if (this.results.data.length <= this.highlightedIndex + 1) {
              this.highlightedIndex = this.results.data.length - 1
            } else {
              this.highlightedIndex = this.highlightedIndex + 1
            }

            document.getElementById(`result-${this.highlightedIndex}`).scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest', 
              inline: 'start' 
            })
          }  
          
          if (event.key === 'ArrowUp') {
            if (this.highlightedIndex === 0) {
              return
            } else if (this.highlightedIndex === null) {
              this.highlightedIndex = this.results.data.length - 1
            } else if (this.highlightedIndex !== null) {
              this.highlightedIndex = this.highlightedIndex - 1
            }

            document.getElementById(`result-${this.highlightedIndex}`).scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest', 
              inline: 'start' 
            })
          } 

          if (event.key === 'Enter') {
            this.select(this.results.data[this.highlightedIndex])
          }
        }
      }
    },

    async searchProducts () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/products/`, {
          params: {
            page: 1,
            sort: 'name',
            dir: 'desc',
            filter: { search: this.search }
          }
        })
        this.results = data.products
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    select (result) {
      this.$emit('selected', result)
      this.$refs.input.blur()
      this.highlightedIndex = null
      this.search = ''
      this.results = {}
    },

    blur () {
      setTimeout(() => {
        this.focused = false
      }, 100)
    }
  }
}
</script>